import { render, staticRenderFns } from "./UpsertCampaignGoalForm.vue?vue&type=template&id=72d0d23b&"
import script from "./UpsertCampaignGoalForm.vue?vue&type=script&lang=js&"
export * from "./UpsertCampaignGoalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports